import {Component, OnDestroy} from "@angular/core";
import {EditService} from "../../../../framework/entity/edit/edit-page/edit.service";
import {EmployeeEntityModel} from "../../employee-entity.model";
import {Subscription} from "rxjs";

@Component({
    selector: "wbo-employee-edit-user",
    templateUrl: "./employee-edit-user.component.html"
})
export class EmployeeEditUserComponent implements OnDestroy {

    private subscriptions: Subscription = new Subscription();

    constructor(public model: EmployeeEntityModel, public editService: EditService) {
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

}
